import { Modal, Title } from '@wyz/ui';
import { PropsWithChildren, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { Trans } from '~/common/context';
import { IUserCustomer } from '~/common/types';
import { SearchBar } from '~/purchase/components';
import { SearchMode } from '~/purchase/reducers';
import { IBaseSearchFormSchema, ISearchTypeArgs } from '~/purchase/types';

type Props = {
  open: boolean;
  onClose: () => void;
  customer: IUserCustomer;
  initialMode: SearchMode;
  searchType: ISearchTypeArgs['searchType'];
};

function SearchModal({
  open,
  onClose,
  customer,
  initialMode,
  searchType,
  children,
}: PropsWithChildren<Props>) {
  const methods = useFormContext<IBaseSearchFormSchema>();
  // important: capture initial values since we're using the same Form => to be used on close modal if the user changes values and then closes the modal
  const initalValues = useRef(methods.getValues());

  return (
    <Modal.Container
      open={open}
      onClose={() => {
        methods.reset(initalValues.current);
        onClose();
      }}
      size='xl'
    >
      <Modal.Header>
        <Modal.Title>
          <Title heading='xl' weight='bold'>
            <Trans i18nKey='app.common.button.new_search' />
          </Title>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SearchBar
          searchType={searchType}
          customer={customer}
          initialMode={initialMode}
        />
      </Modal.Body>
      <Modal.Footer>
        <div className='w-100'>{children}</div>
      </Modal.Footer>
    </Modal.Container>
  );
}

export default SearchModal;
